import { render, staticRenderFns } from "./LessonsDashboard.vue?vue&type=template&id=2e1f033a&scoped=true&"
import script from "./LessonsDashboard.vue?vue&type=script&lang=js&"
export * from "./LessonsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LessonsDashboard.vue?vue&type=style&index=0&id=2e1f033a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1f033a",
  null
  
)

component.options.__file = "LessonsDashboard.vue"
export default component.exports